var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card fuel-funds__card h-mobile-no-border-radius" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "table",
          { staticClass: "maincol__table" },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.transactions, function(transaction, index) {
              return _c("FuelFundsTransaction", {
                key: index,
                attrs: { transaction: transaction }
              })
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-footer" }, [
        _c("div", { staticClass: "fuel-funds__card-total" }, [
          _c("span", { staticClass: "fuel-funds__card-total--transactions" }, [
            _vm._v("Total =")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "fuel-funds__total--amount" }, [
            _vm._v("$" + _vm._s(_vm.transactionsTotal))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h1", { staticClass: "fuel-funds__card-title" }, [
        _vm._v("Transactions")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      {
        staticClass:
          "table__row table__row--head table__row--head--transactions"
      },
      [
        _c("td", { staticClass: "table__cell table__cell--description" }, [
          _vm._v("Description")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--date" }, [
          _vm._v("Date")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--amount" }, [
          _vm._v("Amount")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--action" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }